<template>
    <div class="time_picker">
      <input type="text" placeholder="选择时间" @click="openTIMEFrame" :value="chooseTime" readonly class="time_picker_input"/>
      <transition>
        <div class='timepicker_wrap' v-show="visible">
          <button class="option" @click="closeDateFrame('cancel')">取消</button>
          <button class="option" @click="closeDateFrame('confirm')">确定</button>
          <input :value="time" readonly class="option_input"/>
          <div class='hours'>
            <div class='prev' @mousedown="hoursAdd" @mouseup="holdUp" id="addHour"></div>
            <div class='ti_tx'>{{hours}}</div>
            <div class='next' @mousedown="hoursReduce" @mouseup="holdUp" id="reduceHour"></div>
          </div>
          <div class='minute'>
            <div class='prev' @mousedown="minuteAdd" @mouseup="holdUp" id="addMinute"></div>
            <div class='mi_tx'>{{minute}}</div>
            <div class='next' @mousedown="minuteReduce" @mouseup="holdUp" id="reduceMinute"></div>
          </div>
          <div class='second'>
            <div class='prev' @mousedown="secondAdd" @mouseup="holdUp" id="addSecond"></div>
            <div class='mer_tx'>{{second}}</div>
            <div class='next' @mousedown="secondReduce" @mouseup="holdUp" id="reduceSecond"></div>
          </div>
        </div>
      </transition>

    </div>
</template>

<script>
    export default {
      data(){
        return{
          hours:'00',// 时
          addHours:'',
          reduceHours:'',
          minute:'00',// 分
          addMinute:'',
          reduceMinute:'',
          second:'00',// 秒
          addSecond:'',
          reduceSecond:'',
          timeInterval:0,// 定时时间
          visible:false,
          chooseTime:''// 确认后的选择时间，用于给用户展示和传给用户使用
        }
      },
      computed:{
       time(){
            if(this.hours === '00' && this.minute === '00' && this.second === '00'){
                  return  ''
                }
            return  this.hours + ':' + this.minute + ':' + this.second;
        },
      },

      methods:{
        openTIMEFrame(){// 打开时间选择框
          this.visible = true;
        },
        mousePressTime(data){
          let timeStart;
          let timeEnd;
          timeStart = (new Date()).getTime();
          this.timeInterval = setInterval(()=>{// 定时任务
            timeEnd = (new Date()).getTime();
            if(timeEnd-timeStart>100){
              clearInterval(this.timeInterval);// 清除定时任务
                let e = document.createEvent('MouseEvents');
                e.initEvent("mousedown", true, true);// 事件类型，是否冒泡，是否阻止浏览器默认行为
                document.getElementById(data).dispatchEvent(e);// dispatchEvent触发自定义事件IE不支持，IE使用fireEvent()
            }
          },100)
        },
        holdUp(){
          clearInterval(this.timeInterval);
        },
        hoursAdd(){// 增加小时
          this.addHours++;
          if(this.addHours<=23){
            let id = 'addHour';
            this.mousePressTime(id);
            if(this.addHours<10) this.hours = '0' + this.addHours;
            if(this.addHours>=10) this.hours = this.addHours;
          }else {
            return
          }
        },
        hoursReduce(){//减少小时
          this.reduceHours = parseInt(this.hours);
          if(this.reduceHours>0){
            this.reduceHours-- ;
            let id = 'reduceHour';
            this.mousePressTime(id);
            if(this.reduceHours<10) this.hours ='0' + this.reduceHours;
            if(this.reduceHours>=10) this.hours = this.reduceHours;
          }else {
            return
          }
        },
        minuteAdd(){// 增加分钟
          this.addMinute++;
          if(this.addMinute<=59){
            let id = 'addMinute';
            this.mousePressTime(id);
            if(this.addMinute<10)this.minute = '0' + this.addMinute;
            if(this.addMinute>=10)this.minute = this.addMinute;
          }else return
        },
        minuteReduce(){// 减少分钟
          this.reduceMinute = parseInt(this.minute);
          if(this.reduceMinute>0){
            this.reduceMinute-- ;
            let id = 'reduceMinute';
            this.mousePressTime(id);
            if(this.reduceMinute<10)this.minute ='0' + this.reduceMinute;
            if(this.reduceMinute>=10)this.minute = this.reduceMinute;
          }else return
        },
        secondAdd(){// 增加秒
          this.addSecond++;
          if(this.addSecond<=59){
            let id = 'addSecond';
            this.mousePressTime(id);
            if(this.addSecond<10)this.second = '0' + this.addSecond;
            if(this.addSecond>=10)this.second = this.addSecond;
          }else {
            if(this.hours===23 && this.minute === 59&& this.second === 59){
                return this.hours ='00' , this.minute = '00' , this.second = '00';
            }
            return
          }
        },
        secondReduce(){// 减少秒
          this.reduceSecond = parseInt(this.second);
          if(this.reduceSecond>0){
            this.reduceSecond-- ;
            let id = 'reduceSecond';
            this.mousePressTime(id);
            if(this.reduceSecond<10)this.second ='0' + this.reduceSecond;
            if(this.reduceSecond>=10)this.second = this.reduceSecond;
          }else {
            return
          }
        },
        closeDateFrame(data){
          if(data === 'confirm'){
            this.chooseTime = this.time;
            this.$emit('update:timeValue',this.time);
          }
          this.visible = false;
        }
      }

    }
</script>

<style scoped>
  .time_picker{
    width: 240px;
  }
  .time_picker_input{
    height: 20px;
  }
  .ti_tx, .mi_tx, .mer_tx{
    width: 100%;text-align: center;margin: 10px 0;
  }
  .hours, .minute, .second{
    width: 60px;float: left;margin: 0px 10px;font-size: 20px;color: #2d2e2e;font-family: 'arial';font-weight: 700;
  }
  .prev, .next{
    cursor: pointer;padding: 18px;width: 28%;border: 1px solid #ccc;margin: auto;
    background: url(../assets/arrow.png) no-repeat;border-radius: 5px;
  }
  .prev:hover, .next:hover{
    background-color:#ccc;
  }
  .next{
    background-position: 50% 150%;
  }
  .prev{
    background-position: 50% -50%;
  }
  .timepicker_wrap{
    margin: 10px 0;
    padding: 10px 0;
    border-radius: 5px;
    width:240px;box-shadow: 2px 2px 5px 0 rgba(50, 50, 50, 0.35);
    background:#f6f6f6;border:1px solid #ccc;float:left;top:27px;
  }
  .option{
    font-size: 16px;background: #21A5EF;color: #fff;border-radius: 4px
  }
  .option_input{
    border: 1px solid orange;width: 200px;margin: 10px;height: 30px;font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/timePicker.vue